import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable no-underscore-dangle */
import { useCallback, useState } from 'react';
import classNames from 'classnames';
import { FloatingLabelInput } from '@common/floating-label-input/floating-label-input';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import { typeToName } from '../common/type-to-name';
import styles from './plugin-selector-anchor.css';
export function PluginSelectorAnchor(props) {
    var _a, _b;
    const { value, selectRef, onValueChange, popup, wrapperProps, buttonProps, className, pluginData } = props;
    const { children, ...inputProps } = buttonProps;
    const { className: wrapperClassName, ...restWrapperProps } = wrapperProps;
    const [focused, setFocused] = useState(false);
    const handleInputChange = useCallback((e) => {
        var _a;
        if (selectRef && !((_a = selectRef._popup) === null || _a === void 0 ? void 0 : _a.isVisible())) {
            selectRef._showPopup();
        }
        onValueChange(e.target.value);
    }, [onValueChange, selectRef]);
    // WARNING: This is internals of the ring-ui select implementation, they may change in the future
    const handleFocus = useCallback(() => {
        selectRef === null || selectRef === void 0 ? void 0 : selectRef.setState({ shortcutsEnabled: true, focused: true });
        setFocused(true);
    }, [selectRef]);
    const handleBlur = useCallback(() => {
        var _a, _b, _c;
        if (selectRef && !((_a = selectRef._popup) === null || _a === void 0 ? void 0 : _a.isClickingPopup)) {
            selectRef.setState({
                shortcutsEnabled: false,
                focused: false
            });
            onValueChange((_c = (_b = pluginData === null || pluginData === void 0 ? void 0 : pluginData.pluginDefinition.name) !== null && _b !== void 0 ? _b : pluginData === null || pluginData === void 0 ? void 0 : pluginData.pluginDefinition.id) !== null && _c !== void 0 ? _c : '');
        }
        setFocused(false);
    }, [selectRef, pluginData, onValueChange]);
    const label = pluginData && !focused ? typeToName(pluginData.type) : undefined;
    return (_jsxs("div", { ...restWrapperProps, className: classNames(styles.selectWrapper, wrapperClassName, className), ...assignTestId('plugin-selector-anchor'), children: [_jsx(FloatingLabelInput, { ...inputProps, value: value, onChange: handleInputChange, onBlur: handleBlur, onFocus: handleFocus, className: styles.input, enableShortcuts: focused
                    ? Object.keys({
                        ...selectRef === null || selectRef === void 0 ? void 0 : selectRef.getShortcutsMap(),
                        ...(_b = (_a = selectRef === null || selectRef === void 0 ? void 0 : selectRef._popup) === null || _a === void 0 ? void 0 : _a.list) === null || _b === void 0 ? void 0 : _b.shortcutsMap
                    })
                    : undefined, floatingLabel: label, ...assignTestId('plugin-selector-input') }), popup] }));
}
